export default __webpack_public_path__ + "static/media/Twitter_T.b1e0cfed.svg";